import { IS_LOADING_BANNER_HOME } from "../../ActionType/actionTypes";

export function isLoadingBannerHome(param) {
    return (dispatch) => {
        dispatch({
            type: IS_LOADING_BANNER_HOME, 
            payload: {
                isLoadingBannerHome: param
            }
        })
    }
}